import { useMemo } from 'react';
import { useLocationContext } from '../contexts/LocationContext';

// Categories a location can be tagged with in work orders, schedules,
// SOPs, and customer issues. Labels are derived from the current
// location's equipment counts so a wash with 5 SS bays gets
// "All SS Bays (1-5)" instead of the old hard-coded "1-4".
const GROUPS = [
  { value: 'SS Bay',       countKey: 'num_ss_bays',          singular: 'SS Bay',        plural: 'SS Bays' },
  { value: 'Auto Wash',    countKey: 'num_auto_washes',      singular: 'Auto Wash',     plural: 'Auto Washes' },
  { value: 'Vacuum',       countKey: 'num_vacuums',          singular: 'Vacuum',        plural: 'Vacuums' },
  { value: 'Changer',      countKey: 'num_changers',         singular: 'Changer',       plural: 'Changers' },
  { value: 'Vending',      countKey: 'num_vending_machines', singular: 'Vending Machine', plural: 'Vending Machines' },
  { value: 'Building/Lot', countKey: null,                   singular: 'Building / Lot / Plumbing', plural: 'Building / Lot / Plumbing' },
];

const formatLabel = (group, count) => {
  if (group.countKey === null) return group.singular;
  if (count == null || count === 0) return `All ${group.plural}`;
  if (count === 1) return group.singular;
  return `All ${group.plural} (1-${count})`;
};

// Pure helper. Prefer the hook version below when in a React component.
export const equipmentGroupsFor = (location) => GROUPS.map((g) => ({
  value: g.value,
  label: formatLabel(g, g.countKey ? location?.[g.countKey] : null),
}));

// Hook — reads currentLocation from context and memoizes the result.
export const useEquipmentGroups = () => {
  const { currentLocation } = useLocationContext();
  return useMemo(() => equipmentGroupsFor(currentLocation), [currentLocation]);
};
